import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
}

export const {
  reducer: authReducer,
  actions: { setToken },
} = createSlice({
  name: "auth",
  initialState: { token: null } as AuthState,
  reducers: {
    setToken: (state, action: PayloadAction<{ token: string }>) => {
      state.token = action.payload.token;
    },
  },
});
